import { UseFormRegister, UseFormSetValue, UseFormWatch, UseFormGetValues, UseFormReset, set } from 'react-hook-form';
import { Selector as Selector2 } from 'components/Timeline/components/Selector';
import { CalendarIconContainer, CalendarInputField, QueueSelectorWrapper } from 'pages/Report/utils/ReportFilter';
import { Text } from 'components/Typography';
import { Stack } from 'components/Stack';
import GrayBox from '../../../common/GrayBox';
import { ReportFilterContent } from 'pages/Report/utils/ReportFilterContent';
import theme from 'constants/theme';
import { useForm } from 'react-hook-form';
import { useEffect, useMemo, useState } from 'react';
import dayjs from 'dayjs';
import * as S from '../../style';
import { ReactComponent as IcCalendar } from 'constants/icon/ic_calendar.svg';
import { ReactComponent as IcDateFill } from 'constants/icon/ic_date_fill.svg';
import ComplexDoubleviewDateselector from 'components/ComplexDoubleviewDateselector';
import { date_set_range_template } from 'constants/commons';
import { TPeriodContent } from 'constants/types';
import { FilterSearchbar } from './searchBar/SearchBar';
import { Tab } from 'pages/Setting/common/style';
import { Button } from 'components/Button';
import { IRequestParams, useHistoryRequestParams, useSingleHistoryMessage } from '../../HistoryStore';
import { useSelectingRow } from 'pages/Message/common/CheckSelectStore';
import styled from 'styled-components';
import { useIsDifferenceStore } from 'pages/Message/common/MessagePromptStore';
import { AlertModal } from 'components/Modal/AlertModal';

//해당 클릭 시 초기화 처리해야함
export const MenuList = [
  { code: 'AUTO_MESSAGE', description: '자동 발송' },
  { code: 'MANUAL_MESSAGE', description: '수동(예약) 발송' },
  { code: 'EXCEPTION_MESSAGE', description: '발송 제외' },
];
export const RecipentList = [
  { code: 'all', description: '전체' },
  { code: 'client', description: '고객' },
  { code: 'driver', description: '기사' },
  { code: 'salesman', description: '중개사' },
  { code: 'consignor', description: '화주사' },
];
export const keywordTypeList = {
  AUTO_MESSAGE: [
    { key: '고객명', value: 'consigneeName', placeholder: '고객명을 입력해 주세요' },
    { key: '제목', value: 'messageTitle', placeholder: '제목을 입력해주세요' },
  ],
  MANUAL_MESSAGE: [
    { key: '고객명', value: 'consigneeName', placeholder: '고객명을 입력해 주세요' },
    { key: '제목', value: 'messageTitle', placeholder: '제목을 입력해주세요' },
  ],
  EXCEPTION_MESSAGE: [
    { key: '고객명', value: 'consigneeName', placeholder: '고객명을 입력해 주세요' },
    { key: '제목', value: 'messageTitle', placeholder: '제목을 입력해주세요' },
  ],
};

type Props = {};

export default function MessageHistoryFilterComponent({}: Props) {
  const { requestParams, setRequestParams } = useHistoryRequestParams();
  const { singleHistoryMessage, setSingleHistoryMessage } = useSingleHistoryMessage();
  const { setselectRow } = useSelectingRow();
  const { isDifference, setIsDifference } = useIsDifferenceStore();

  const [CDDIsOpen, setCDDIsOpen] = useState<boolean>(false);
  const localStateMethod = useForm<Partial<IRequestParams>>({
    mode: 'onSubmit',
    defaultValues: {
      recipentType: requestParams.recipentType,
      startDate: requestParams.startDate,
      endDate: requestParams.endDate,
      keywordType: requestParams.keywordType,
      keyword: requestParams.keyword,
    },
  });

  // 임시 작성 중 취소 모달 상태
  const [isOpenCancelChangeModal, setIsOpenCancelChangeModal] = useState(false);
  // 임시 작성 모달 띄울 때 이전에 선택한 tab 정보
  const [snapshotTabCode, setSnapshotTabCode] = useState<string | null>(null);
  // 임시 작성 중 취소 모달 닫기
  const onClickModalWriteCancel = () => {
    if (!!snapshotTabCode) {
      // 취소 버튼 클릭 시 isDifference false 처리
      setIsDifference(false);
      // snapshotTabCode 를 onClickMenuTab 함수에 넘겨서 탭 변경 처리
      onClickMenuTab(snapshotTabCode, false);
      // 모달 닫기 처리
      setIsOpenCancelChangeModal(false);
    }
  };

  // 탭 변경 처리 함수
  const onClickMenuTab = (code: string, isDifference: boolean) => {
    // isDifference 가 true 일 때만 모달 띄우기 + snapshotTabCode 저장
    if (isDifference) {
      setIsOpenCancelChangeModal(true);
      setSnapshotTabCode(code);
    } else {
      // 탭 변경 시 로컬 필터 전부 초기화(상단 요청 + 로컬 필터 전부 처리)
      if (code === 'AUTO_MESSAGE') {
        // 자동 발송
        // 요청 필터 초기화
        setRequestParams({
          tabType: code,
          recipentType: RecipentList[0].code,
          startDate: dayjs().subtract(7, 'day').format('YYYY-MM-DD'),
          endDate: dayjs().format('YYYY-MM-DD'),
          keywordType: keywordTypeList['AUTO_MESSAGE'][0].value,
          keyword: '',
        });
        // 로컬 필터 초기화
        localStateMethod.reset({
          recipentType: RecipentList[0].code,
          startDate: dayjs().subtract(7, 'day').format('YYYY-MM-DD'),
          endDate: dayjs().format('YYYY-MM-DD'),
          keywordType: keywordTypeList['AUTO_MESSAGE'][0].value,
          keyword: '',
        });
      } else if (code === 'MANUAL_MESSAGE') {
        // 수동(예약) 발송
        // 요청 필터 초기화
        setRequestParams({
          tabType: code,
          startDate: dayjs().subtract(7, 'day').format('YYYY-MM-DD'),
          endDate: dayjs().format('YYYY-MM-DD'),
          keywordType: keywordTypeList['MANUAL_MESSAGE'][0].value,
          keyword: '',
        });
        // 로컬 필터 초기화
        localStateMethod.reset({
          startDate: dayjs().subtract(7, 'day').format('YYYY-MM-DD'),
          endDate: dayjs().format('YYYY-MM-DD'),
          keywordType: keywordTypeList['MANUAL_MESSAGE'][0].value,
          keyword: '',
        });
      } else if (code === 'EXCEPTION_MESSAGE') {
        // 발송 제외
        // 요청 필터 초기화
        setRequestParams({
          tabType: code,
          recipentType: RecipentList[0].code,
          startDate: dayjs().subtract(7, 'day').format('YYYY-MM-DD'),
          endDate: dayjs().format('YYYY-MM-DD'),
          keywordType: keywordTypeList['EXCEPTION_MESSAGE'][0].value,
          keyword: '',
        });
        // 로컬 필터 초기화
        localStateMethod.reset({
          recipentType: RecipentList[0].code,
          startDate: dayjs().subtract(7, 'day').format('YYYY-MM-DD'),
          endDate: dayjs().format('YYYY-MM-DD'),
          keywordType: keywordTypeList['EXCEPTION_MESSAGE'][0].value,
          keyword: '',
        });
      }
      // row 선택 초기화
      setSingleHistoryMessage(null);
      setselectRow('');
      // 기존에 선택했던 snapshotTabCode 초기화
      setSnapshotTabCode(null);
    }
  };

  const onClickSubmit = () => {
    setRequestParams({
      tabType: requestParams.tabType,
      recipentType: localStateMethod.getValues('recipentType'),
      startDate: localStateMethod.getValues('startDate') ?? dayjs().subtract(7, 'day').format('YYYY-MM-DD'),
      endDate: localStateMethod.getValues('endDate') ?? dayjs().format('YYYY-MM-DD'),
      keywordType: localStateMethod.getValues('keywordType') ?? keywordTypeList['AUTO_MESSAGE'][0].value,
      keyword: localStateMethod.getValues('keyword') ?? '',
    });
    // row 선택 초기화
    setSingleHistoryMessage(null);
    setselectRow('');
  };

  return (
    <>
      <Stack name="tab-and-filter" sx={{ display: 'flex', flexDirection: 'column' }}>
        <Stack name="order-page-tap-by-status" direction={'row'}>
          {MenuList.map((menuData, idx) => {
            return (
              <Tab
                key={menuData.code}
                index={idx}
                isActive={menuData.code === requestParams.tabType}
                onClick={e => {
                  onClickMenuTab(menuData.code, isDifference);
                }}
              >
                {menuData.description}
              </Tab>
            );
          })}
        </Stack>
        <GrayBox
          sx={{
            borderRadius: '0px 12px 12px 12px',
            display: 'flex',
            flexDirection: 'column',
            padding: '12px 16px',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Stack sx={{ display: 'flex', flexDirection: 'row' }}>
            <Stack>
              {!!localStateMethod.watch('recipentType') && (
                <Stack
                  name="sub-filter-wrapper"
                  sx={{
                    margin: '20px 0 0 0',
                    minHeight: 'fit-content',
                    maxHeight: '270px',
                    transition: 'all .6s',
                  }}
                  style={{ alignItems: 'start', gap: 6, marginBottom: '10px' }}
                >
                  <ReportFilterContent
                    title="수신인 종류"
                    altInfo={`수신인 종류 필터입니다.`}
                    anchor="bottom"
                    direction="row"
                    gap={20}
                  >
                    <QueueSelectorWrapper direction={'row'} sx={{ width: '448px', marginLeft: '12px', height: '30px' }}>
                      {RecipentList.map(recipentData => {
                        return (
                          <S.QueueSelectorContainerCustom
                            key={`${recipentData.code}_receiver`}
                            selected={localStateMethod.watch('recipentType') == recipentData.code}
                            width={78}
                            onClick={() => {
                              localStateMethod.setValue('recipentType', recipentData.code);
                            }}
                            // disabled={['중개사', '화주사'].includes(recipentData.code)}
                          >
                            <Text
                              styleName={'caption2'}
                              color={localStateMethod.watch('recipentType') == recipentData.code ? 'RC02' : 'RG02'}
                            >
                              {recipentData.description}
                            </Text>
                          </S.QueueSelectorContainerCustom>
                        );
                      })}
                    </QueueSelectorWrapper>
                  </ReportFilterContent>
                </Stack>
              )}
              <Stack name="date-range-filter-area" direction="row" spacing={16} sx={{ flex: 1 }}>
                <Stack
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    // width: '360px',
                    backgroundColor: 'white',
                    height: '32px',
                    border: `1px solid ${theme.colors.RG06}`,
                    borderRight: '0px',
                    borderRadius: '6px 6px 6px 6px',
                  }}
                >
                  {/* <Selector2
                  displayKey={'발송일'}
                  width={90}
                  extension={126}
                  scrollCriteria={32 * 6 + 2}
                  gap={13}
                  outline={false}
                  fill={false}
                  onClick={(e, v) => {
                    // setDisplayContent(v.key);
                    // localStateMethod.setValue('', v.value);
                  }}
                  // onchange setmethod value to key
                  options={[
                    { key: '발송일', value: '발송일' },
                    { key: 'test', value: 'test' },
                  ]}
                  placeholder={'발송일'}
                /> */}
                  <SecondFilterInnerTextDiv>발송일</SecondFilterInnerTextDiv>
                  <ComplexDoubleviewDateselector
                    parent={
                      <CalendarInputField
                        style={{ borderRadius: '0px 5px 5px 0px', height: '32px', borderLeft: '0px', width: '100%' }}
                        isActive={CDDIsOpen}
                        hasError={false}
                      >
                        <CalendarIconContainer
                          isActive={CDDIsOpen}
                          hasError={false}
                          style={{ backgroundColor: 'white' }}
                        >
                          {/* <IcCalendar /> */}
                          <IcDateFill />
                        </CalendarIconContainer>
                        <input
                          readOnly
                          {...localStateMethod.register('startDate', {
                            minLength: {
                              value: 10,
                              message: '',
                            },
                            maxLength: {
                              value: 10,
                              message: '',
                            },
                            pattern: {
                              value: /^\d{4}.(0[1-9]|1[012]).(0[1-9]|[12][0-9]|3[01])$/,
                              message: '',
                            },
                          })}
                          autoComplete="off"
                          onFocus={e => setCDDIsOpen(true)}
                        />
                        {'~'}
                        <input
                          readOnly
                          {...localStateMethod.register('endDate', {
                            minLength: {
                              value: 10,
                              message: '',
                            },
                            maxLength: {
                              value: 10,
                              message: '',
                            },
                            pattern: {
                              value: /^\d{4}.(0[1-9]|1[012]).(0[1-9]|[12][0-9]|3[01])$/,
                              message: '',
                            },
                          })}
                          autoComplete="off"
                          onFocus={e => setCDDIsOpen(true)}
                        />
                      </CalendarInputField>
                    }
                    {...{
                      initDate: [
                        dayjs(localStateMethod.getValues('startDate')).toDate(),
                        dayjs(localStateMethod.getValues('endDate')).toDate(),
                      ],
                      methods: localStateMethod,
                      isOpen: CDDIsOpen,
                      setIsOpen: setCDDIsOpen,
                    }}
                  />
                </Stack>
                <Stack sx={{ maxWidth: '360px' }}>
                  <FilterSearchbar
                    {...{
                      methods: localStateMethod,
                      //@ts-ignore
                      content: keywordTypeList[requestParams.tabType],
                    }}
                  />
                </Stack>
              </Stack>
            </Stack>
            <Stack align="end" style={{ minWidth: 100 }}>
              <Button
                variant="secondary"
                h={32}
                onClick={onClickSubmit}
                sx={{ padding: '0 16px', position: 'relative', top: '50%', right: '10px' }}
              >
                조회하기
              </Button>
            </Stack>
          </Stack>
        </GrayBox>
      </Stack>
      <AlertModal
        type="WARNING"
        isOpen={isOpenCancelChangeModal}
        messages={
          <Stack sx={{ gap: '8px' }}>
            <Text styleName="body2" color="RG02">
              수정을 취소하시겠습니까?
            </Text>
            <Text styleName="body2" color="RG02">
              작성 중이던 내용은 저장되지 않습니다.
            </Text>
          </Stack>
        }
        buttonGroup={
          <ModalButtonDiv>
            <Button
              variant="tertiary"
              h={40}
              sx={{ width: '100%', marginTop: '40px' }}
              onClick={() => setIsOpenCancelChangeModal(false)}
            >
              <Text styleName="body1" color="RG03">
                계속 작성
              </Text>
            </Button>
            <Button
              variant="primary"
              h={40}
              sx={{ width: '100%', marginTop: '40px' }}
              onClick={onClickModalWriteCancel}
            >
              <Text styleName="body1" color="RG00">
                작성 취소
              </Text>
            </Button>
          </ModalButtonDiv>
        }
      />
    </>
  );
}

const SecondFilterInnerTextDiv = styled.div`
  display: flex;
  padding: 5px 5px 5px 7px;
  align-items: center;
  gap: 12px;
  width: 70px;

  color: var(--RG02, #25282f);
  font-feature-settings: 'liga' off, 'clig' off;

  /* body14M */
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 171.429% */
  letter-spacing: -0.28px;
`;
const ModalButtonDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  align-self: stretch;
`;
